/** 화면을 짜는 데만 쓰는 최소 도구. 프레임워크를 들일 만한 규모가 아니다. */

export type Child = Node | string | null | undefined | false;

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Record<string, string> = {},
  ...children: Child[]
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (k === 'class') node.className = v;
    else if (k === 'text') node.textContent = v;
    else node.setAttribute(k, v);
  }
  for (const c of children) {
    if (c === null || c === undefined || c === false) continue;
    node.append(typeof c === 'string' ? document.createTextNode(c) : c);
  }
  return node;
}

export function button(label: string, onClick: () => void, cls = ''): HTMLButtonElement {
  const b = el('button', { class: cls, type: 'button' }, label);
  b.addEventListener('click', onClick);
  return b;
}

/**
 * 단추에 열쇠(`data-key`)를 단다. 화면을 통째로 다시 그린 뒤 같은 단추를 찾아 제자리에 두는 데 쓴다
 * (출정·장비 화면의 `render`).
 */
export function withKey<T extends HTMLElement>(node: T, key: string): T {
  node.dataset.key = key;
  return node;
}

export function clear(node: HTMLElement): void {
  while (node.firstChild) node.removeChild(node.firstChild);
}

/**
 * 이름 뒤에 붙는 주격 조사. 받침이 있으면 '이', 없으면 '가'.
 *
 * "을두지이 합류했다"가 되는 것을 막는다. 한글 음절은 0xAC00부터 28개씩 묶여
 * 있고 그 안에서 종성이 0이면 받침이 없다. 이름이 한글이 아니면(숫자나 로마자
 * 식별자가 잘못 들어오면) '가'로 둔다 — 틀려도 읽을 수는 있다.
 */
/** 목적격 조사. 받침이 있으면 '을', 없으면 '를'("삼년산성을", "하슬라를"). 한글이 아니면 '를'. */
export function objectJosa(word: string): string {
  const last = word.trim().slice(-1);
  const code = last.charCodeAt(0);
  if (Number.isNaN(code) || code < 0xac00 || code > 0xd7a3) return '를';
  return (code - 0xac00) % 28 === 0 ? '를' : '을';
}

export function subjectJosa(word: string): string {
  const last = word.trim().slice(-1);
  const code = last.charCodeAt(0);
  if (Number.isNaN(code) || code < 0xac00 || code > 0xd7a3) return '가';
  return (code - 0xac00) % 28 === 0 ? '가' : '이';
}
